import { AppTheme } from '../../types/theme';
import { css } from 'styled-components';

export default function (theme: AppTheme) {
    const sassVars = theme.variables.sass as any;
    return css`
        margin-bottom: ${sassVars.formElementLabelMarginBottom};
        color: ${sassVars.formElementLabelColor};
        font-family: ${sassVars.formElementLabelFontFamily};
        font-size: ${sassVars.formElementLabelFontSize};
        font-weight: ${sassVars.formElementLabelFontWeight};
        line-height: ${sassVars.formElementLabelLineHeight};
        letter-spacing: ${sassVars.formElementLabelLetterSpacing};
    `;
}
